import { Button, Card, CardActions, Typography, styled, Box, IconButton, Tooltip } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import { RootState } from "../../redux/reducers/rootState";
import { getQueryParameterByName } from "../../utils";
import LabeledValue from "../shared-components/LabeledValue";
import PageWithDescription from "../shared-components/PageWithDescription";
import styles from "./VerdictCard.module.scss";
import { saveSearches, getSavedSearches } from '../../redux/actions/search';
import { deleteFavDocument } from "../../redux/actions/favorites";
import FavoriteModal from '../FavoriteModal';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { confirm } from "../ConfirmDialog/confirm";

interface Props {
    verdict: any;
    isFavorited: any;
}

const MainCardContent = styled(Box)(({theme}) => ({
    backgroundColor: "rgba(223,231,238,0.5)",
    padding: theme.spacing(2, 2, 2, 2)
}));

export default function VerdictCard(props: Props) {
    const dispatch: any = useDispatch();

    const totalVerdicts = useSelector((state: RootState) => state.verdicts.totalVerdicts);
    const verdictFilters = useSelector((state: RootState) => state.verdictsFilters.appliedVerdictsFilters);
    const favList = useSelector((state: RootState) => state.favorites.favoriteDocuments);
    const expandItems = 2;
    const [visibleItems, setVisibleItems] = useState(1);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleShowMoreButtonClick = () => {
        const remainingItems = props.verdict.highlightedTexts.length - visibleItems;
        const itemsToExpand =  remainingItems < expandItems ? remainingItems : expandItems;
        setVisibleItems(visibleItems + itemsToExpand);
    }

    const handleCollapseButtonClick = () => {
        setVisibleItems(1);
    }

    const phrase = getQueryParameterByName("q");

    const saveSearch = () => {
        const dataSearch = {
            "phrase": phrase,
            "type": "VERDICT",
            "totalHits": totalVerdicts,
            "maxResults": 40,
            "slop": 10,
        }
        dispatch(saveSearches(dataSearch)).then((res: any) => {
            dispatch(getSavedSearches());
        });
    }

    // const onDeleteFavDocument = async(id: any) => {
    //     if(!await confirm(null, {title: "Dëshironi ta fshini dokumentin e ruajtur?", cancelButton: "Jo"})) {
    //         return;
    //     }
    //     dispatch(deleteFavDocument(id));
    // }

    const handleClickFavorite = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseFavorite = () => {
        setAnchorEl(null);
    };

    return (
        <Card sx={{ mb: 1.5 }}>
            <Box>
                <MainCardContent>
                    <div className={styles.VerdictCardTitleWrapper}>
                        <Typography variant="h6" color="text.secondary" onClick={saveSearch}>
                            <RouterLink style={{textDecoration: 'none'}} to={`/verdicts/${encodeURIComponent(props.verdict.id)}/?q=${phrase}`}>
                                {props.verdict?.documentName}
                            </RouterLink>
                        </Typography>
                        {/* {props.isFavorited ? (
                            <Tooltip title="Fshije dokumentin" placement="right" arrow>
                                <div>
                                    <IconButton color="primary" onClick={() => onDeleteFavDocument(props.isFavorited)}>
                                        <BookmarkIcon />
                                    </IconButton>
                                </div>
                            </Tooltip>
                        ) : ( */}
                        <Tooltip title="Ruaje dokumentin" placement="right" arrow>
                            <div>
                                <IconButton
                                    onClick={handleClickFavorite}
                                >
                                    <BookmarkBorderIcon />
                                </IconButton>
                                <FavoriteModal 
                                    show={anchorEl} 
                                    handleClose={handleCloseFavorite} 
                                    typeOfDocument="VERDICT"
                                    document={props.verdict}
                                />
                            </div>
                        </Tooltip>
                    </div>
                    <div className={styles.VerdictCardDescriptionWrapper}>
                        <LabeledValue type="normal" label="Lloji" value={props.verdict.documentType} />
                        <LabeledValue type="normal" label="Gjykata" value={props.verdict.court} />
                        <LabeledValue type="normal" label="Dega" value={props.verdict.branch} />
                        <LabeledValue type="normal" label="Numri i rastit" value={props.verdict.caseNumber} />
                        <LabeledValue type="normal" label="Gjyqtar" value={props.verdict.judge} />
                        <LabeledValue onSaveSearch={saveSearch} type="link" label="Linku zyrtar" value={props.verdict.officialLink} />
                    </div>
                </MainCardContent>

                {props.verdict?.highlightedTexts.map((text: any, index: number) => {
                    const isRowVisible = ((index + 1) <= visibleItems);
                    return (
                        isRowVisible && <PageWithDescription page={text.page} text={text.highLightedText} />
                    )
                })}

            </Box>
            <CardActions sx={{display: 'flex', justifyContent: 'end'}}>
                {!!(props.verdict.highlightedTexts.length - visibleItems) && <Button
                    size="small"
                    disabled={visibleItems >= props.verdict.highlightedTexts.length}
                    onClick={handleShowMoreButtonClick}>
                    Shfaq më shumë ({props.verdict.highlightedTexts.length - visibleItems})
                </Button>}
                {visibleItems > 1 && <Button
                    size="small"
                    onClick={handleCollapseButtonClick}>
                    Mbyll të gjitha
                </Button>}
            </CardActions>

        </Card>
    )
}
